import React from "react";

export default function Button({ filter, onClick }) {

  //Uses 'selected' property (true/false value) of filter to update the ID name to reflect correct styling for Selected/Unselected button
  function getClassName(selected) {

    if (selected) {
        return 'moreSelected';
      } else {
        return 'more';
      }
  }
  
  return (
    <div
      className={getClassName(filter.selected)} //Updates class name  through getClassName functino
      id={filter.filter} //Sets id to the property 'filter' of the current filter button being made
      onClick={() => onClick(filter.id)} //Sends the ID of the clicked filter back to Filters
    >
      <img src={filter.icon} alt={filter.filter}></img> {/* Grabs the icon url from the object */}
      <span>{filter.span}</span> {/* Grabs the span property from the object */}
    </div>
  );
}